module.exports = __webpack_public_path__ + "img/ingPay.cec414b.png";